import { RootState } from "store/store";

export const selectRouteLoading = (state: RootState) => {
  return state.route.loading;
};

export const selectCurrentRoute = (state: RootState) => {
  return state.route.current;
};

export const selectCurrentRouteResponse = (state: RootState) => {
  return state.route.response;
};

export const selectCurrentRouteRequest = (state: RootState) => {
  return state.route.request;
};

export const selectHotels = (title?: string) => (state: RootState) => {
  const hotels = title ? state.route.hotels[title] : [];
  return hotels ?? [];
};
